import {
  deletePrivateMoneyExchage,
  getPrivateMoneyExchanges,
} from 'admin/actions/private-money-exchanges';
import BreadCrumb from 'admin/components/molecules/BreadCrumb';
import { toQueryParams } from 'admin/utils';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useAppSelector } from '~/javascripts/admin/hooks/useApp';
import { Button } from '../../atoms/Buttons';
import Headings from '../../atoms/Headings';
import ApiResult from '../../shared/ApiResult';
import FilterForm from './FilterForm';
import ListTable from './ListTable';

type GetExchangesResponse = Awaited<ReturnType<typeof getPrivateMoneyExchanges>>;

const FormWrapper = styled.div``;

const Row = styled.div`
  padding: 10px 0;
`;

const CRUMBS = [
  { value: 'ホーム', href: '/', isCurrentPage: false },
  { value: '各種設定', href: '', isCurrentPage: true },
  { value: 'マネー間交換管理', href: '', isCurrentPage: true },
];

const defaultApiResult = { message: '', isError: false };

const PrivateMoneyExchanges = () => {
  const [filterParams, setFilterParams] = useState<{ private_money_id?: string }>({});
  const [exchanges, setExchanges] = useState<GetExchangesResponse | null>(null);
  const [apiResult, setApiResult] = useState(defaultApiResult);

  const user = useAppSelector((state) => state.user);
  const canEdit = user.isManagerUser();

  const onChangePage = (page: number) => {
    getPrivateMoneyExchanges(toQueryParams({ page, ...filterParams }, true)).then((res) => {
      setExchanges(res);
    });
  };

  const applyFilters = (params: { private_money_id: string }) => {
    setFilterParams(params);
    getPrivateMoneyExchanges(toQueryParams({ page: 1, ...params }, true)).then((res) => {
      setExchanges(res);
    });
  };

  const onDeleteItem = (id: number) => {
    deletePrivateMoneyExchage(`${id}`)
      .then(() => {
        setApiResult({ message: '対象の設定を削除しました', isError: false });
        getPrivateMoneyExchanges(toQueryParams({ page: 1, ...filterParams }, true)).then((res) => {
          setExchanges(res);
        });
      })
      .catch((e) =>
        Promise.resolve(e).then((err) =>
          setApiResult({
            message: err?.message,
            isError: true,
          })
        )
      )
      .finally(() => {
        setTimeout(() => setApiResult(defaultApiResult), 10000);
      });
  };

  return (
    <FormWrapper>
      <BreadCrumb crumbs={CRUMBS} />
      {apiResult.message && <ApiResult message={apiResult.message} isError={apiResult.isError} />}
      {canEdit && (
        <Row>
          <Link to="/settings/private-money-exchange/create">
            <Button type="button">新規登録</Button>
          </Link>
        </Row>
      )}
      <Headings.h5>検索条件</Headings.h5>
      <FilterForm applyFilters={applyFilters} />
      {exchanges != null ? (
        <ListTable
          exchanges={exchanges.rows}
          pagination={exchanges.pagination}
          onChangePage={onChangePage}
          onDeleteItem={onDeleteItem}
          canEdit={canEdit}
        />
      ) : null}
    </FormWrapper>
  );
};

export default PrivateMoneyExchanges;
